var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassEffect2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1248,
    height: 1258,
    viewBox: "0 0 1248 1258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2882_58717",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4775 864.17L757.477 118.181L968.672 331.084L228.672 1077.07L17.4775 864.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.4775 864.17L757.477 118.181L968.672 331.084L228.672 1077.07L17.4775 864.17Z",
    fill: "url(#paint0_linear_2882_58717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1629 864.861L758.163 118.871L756.792 117.49L16.7922 863.479L18.1629 864.861Z",
    fill: "url(#paint1_linear_2882_58717)",
    fillOpacity: 0.2,
    mask: "url(#path-1-inside-1_2882_58717)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_2882_58717",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1044.28L1035.89 -0.000346855L1247.09 212.904L211.194 1257.18L0 1044.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 1044.28L1035.89 -0.000346855L1247.09 212.904L211.194 1257.18L0 1044.28Z",
    fill: "url(#paint2_linear_2882_58717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.68538 1044.97L1036.58 0.690581L1035.21 -0.691275L-0.68538 1043.59L0.68538 1044.97Z",
    fill: "url(#paint3_linear_2882_58717)",
    fillOpacity: 0.2,
    mask: "url(#path-3-inside-2_2882_58717)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2882_58717",
    x1: 115.68,
    y1: 430.743,
    x2: 375.917,
    y2: 688.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084478"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2882_58717",
    x1: 387.477,
    y1: 491.175,
    x2: 600.374,
    y2: 702.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E2F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2882_58717",
    x1: 203.793,
    y1: 504.404,
    x2: 464.031,
    y2: 762.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084478"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2882_58717",
    x1: 517.946,
    y1: 522.138,
    x2: 730.843,
    y2: 733.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E2F4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassEffect2);
export default __webpack_public_path__ + "static/media/glass-effect2.fdd5e5fcea91182d52bf92dee26b5cf3.svg";
export { ForwardRef as ReactComponent };